import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import CardComponent from '../../../components/Card.component';
import { useAppDispatch } from '../../../hooks/useAppDispatcher.hook';
import { useAppSelector } from '../../../hooks/useAppSelector.hook';
import { useTranslation } from 'react-i18next';
import SpinnerComponent from '../../../components/Spinner.component';
import {
  setHeaderActions, // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
  setHeaderSubTitle, // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
  setHeaderTitle, // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
} from '../../../redux/App/App.slice';
import { HeaderActionIcons } from '../../../components/Icons/HeaderAction.icons';
import { useModalManager } from '../../../hooks/ModalManager.hook';
import { ALERT_ACTION_ENUM } from '../../../types/action.types';
import { HeaderActionTypes } from '../../../types/header.types';
import {
  getInternshipPeopleList,
  getInternshipSelected,
  resetInternshipSelectedAction,
} from '../../../redux/Internship/Internship.slice';
import {
  removeCandidateInternshipThunk,
  destroyInternshipThunk,
  getInternshipInfoThunk,
  getInternshipPeopleListThunk,
} from '../../../redux/Internship/Internship.thunk';
import InternshipInfoBlockComponent from '../../../components/Blocks/InternshipInfoBlock.component';
import InternshipEditModalComponent from '../../../components/Modal/Internship/InternshipEditModal.component';
import NoResultComponent from '../../../components/NoResult.component';
import { Person } from '../../../redux/Candidate/Candidate.type';
import NotAssignComponent from '../../../components/NotAssign.component';
import BadgeComponent from '../../../components/Badge.component';
import TableComponent from '../../../components/Table/Table.component';
import PlusIcon from '../../../components/Icons/Plus.icon';
import { TableHeaderItemOrderProps } from '../../../components/Table/TableHeader.component';
import TableRowComponent from '../../../components/Table/TableRow.component';
import { debounce, uniqueId } from 'lodash';
import ButtonComponent from '../../../components/Button.component';
import ApiWrapper from '../../../hooks/useApi.hook';
import { RoutesConstant } from '../../../constants/routes.constant';
import InternshipRemoveAlert from '../../../components/Alert/Internship/InternshipRemoveAlert';
import InternshipAddCandidateModal from '../../../components/Modal/Internship/InternshipAddCandidateModal';
import { getUrlBasedOnCurrentPath } from '../../../components/Modal/Candidate/utils';
import { checkUserRequiredPermissions } from '../../../utils/getUserRolesByToken';
import { UserPermissions } from '../../../types/userPermissions.types';
import useAuthHook from '../../../hooks/useAuth.hook';
import {
  addToQueryString,
  getFilters,
  getPage,
  getSearch,
  getSort,
} from '../../../services/router.service';
import { SortTypes } from '../../../types/sort.types';
import InputComponent from '../../../components/Input/Input.component';
import SelectComponent, {
  SelectGroupedOption,
  SelectOptionProps,
} from '../../../components/Input/Select.component';
import useStatusHook from '../../../hooks/useStatus.hook';
import AttachmentsBlockComponent from '../../../components/Blocks/AttachmentsBlockComponent.component';
import InternshipCandidateRemoveAlert from '../../../components/Alert/Internship/InternshipCandidateRemoveAlert';
import InternshipCommentBlock from '../../../components/Blocks/InternshipCommentBlock';
import { CANDIDATES_GROUPS } from '../../../types/candidates.types';
import CandidatePreviewModalComponent from '../../../components/Modal/Candidate/CandidatePreviewModal.component';
import {
  StyledFilterWrapper,
  StyledInternshipInfo,
  StyledInternshipInfoBlocks,
  StyledInternshipInfoTitle,
  StyledInternshipPage,
  StyledInternshipRecords,
  StyledInternshipRecordsHeader,
  StyledInternshipRecordsHeaderActions,
  StyledInternshipRecordsHeaderTitle,
  StyledStatusGroup,
} from './Internship.styles';
import { TABLE_HEADER_COLUMNS } from './constants/constants';
import i18n from 'i18next';
import { StatusColor } from '../../../constants/statusColors.constant';

const InternshipPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { openModal, closeModal } = useModalManager();
  const info = useAppSelector(getInternshipSelected);
  const list = useAppSelector(getInternshipPeopleList);
  const { id } = useParams<string>();
  const { t } = useTranslation();
  const [, setSearchParams] = useSearchParams();
  const { user } = useAuthHook();
  const location = useLocation();
  const [searchString, setSearchString] = useState<string>('');
  const [statuses, setStatuses] = useState<SelectOptionProps[]>([]);
  const {
    getSelectWholeList: getStatusList,
    getSelectListByIds: getStatusById,
  } = useStatusHook();

  useEffect(() => {
    if (!id) return;
    dispatch(setHeaderSubTitle('Group internships')); // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
    dispatch(setHeaderTitle(t('Loading'))); // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
    dispatch(getInternshipInfoThunk(id));
    const status = getFilters(window.location.search, 'status');
    const search = getFilters(window.location.search, 'search') || null;
    setSearchString(search as string);
    if (status && Array.isArray(status) && status.length > 0) {
      getStatusById(status as Array<number>).then((status: any) => {
        setStatuses(status);
        handleStatusesChange(status);
      });
    } else {
      handleChangeSearch(search as string);
    }

    return () => {
      dispatch(setHeaderSubTitle(undefined)); // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
      dispatch(resetInternshipSelectedAction(undefined));
    };
  }, [id]);

  useEffect(() => {
    if (!info.item) return;
    dispatch(setHeaderTitle(info.item.name)); // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
    dispatch(
      setHeaderActions([
        // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
        {
          icon: HeaderActionIcons.EDIT,
          type: HeaderActionTypes.ICON_BUTTON,
          action: () => openModal(InternshipEditModalComponent),
        },
        {
          icon: HeaderActionIcons.DELETE,
          type: HeaderActionTypes.ICON_BUTTON,
          action: () =>
            openModal(InternshipRemoveAlert, {
              handleConfirm: handleConfirmDelete,
            }),
        },
      ]),
    );

    return () => {
      dispatch(setHeaderActions([])); // TODO: это не эффект и уж точно не стейт. Вынестии в статику страницы
    };
  }, [info]);

  const currentSearch: string = useMemo<string>(() => {
    return getSearch(window.location.search) || '';
  }, [window.location.search]);

  const currentPage: number = useMemo<number>(() => {
    return getPage(window.location.search) || 1;
  }, [window.location.search]);

  const currentSort: string = useMemo<string>(() => {
    return getSort(window.location.search) || 'full_name';
  }, [window.location.search]);

  const currentStatuses = useMemo(() => {
    return {
      status: getFilters(window.location.search, 'status') || undefined,
    };
  }, [window.location.search]);

  const handleConfirmDelete = useCallback(
    (action?: ALERT_ACTION_ENUM) => {
      if (!action || !info.item) return;
      if (action && action !== ALERT_ACTION_ENUM.YES) return;
      ApiWrapper(destroyInternshipThunk(info.item.id)).then((res: boolean) => {
        res && navigate(RoutesConstant.INTERNSHIPS);
      });
    },
    [dispatch, info],
  );

  const handleSearchCandidate = useCallback(() => {
    openModal(InternshipAddCandidateModal, {
      internshipId: info.item.id,
      internshipRegions: info.item.regions,
      activeCandidates: list.items,
    });
  }, [info]);

  const handleConfirmRemoveCandidate = (personId: string | number) => {
    openModal(InternshipCandidateRemoveAlert, {
      handleConfirm: (action?: ALERT_ACTION_ENUM) =>
        handleRemoveCandidate(action, personId),
    });
  };

  const handleRemoveCandidate = async (
    action: ALERT_ACTION_ENUM | undefined,
    personId: string | number,
  ) => {
    if (!action || action !== ALERT_ACTION_ENUM.YES) return;
    if (id) {
      await dispatch(
        removeCandidateInternshipThunk({
          candidateId: personId,
          internshipId: id,
        }),
      );
    }
    closeModal();
  };

  const prepareRowColumns = (item: Person) => {
    const telegramLink = Array.isArray(item.links)
      ? item.links.find(link => link.type === 'TELEGRAM')
      : null;
    return [
      item.fullName,
      <NotAssignComponent mode="badge" has={!!item.status}>
        <BadgeComponent
          appearance="default"
          color={
            item.statusColor &&
            i18n.exists(`statusColor.${item.statusColor}`)
              ? `STATUSES_${item.statusColor.toUpperCase()}`
              : item.statusColor || `STATUSES_${StatusColor.GREY.toUpperCase()}`
          }
          textColor={
            item.statusTextColor &&
            i18n.exists(`statusColor.${item.statusTextColor}`)
              ? `STATUSES_${item.statusTextColor.toUpperCase()}`
              : item.statusTextColor ||
              `STATUSES_${StatusColor.GREY.toUpperCase()}`
          }
          text={item.status!}
        />
      </NotAssignComponent>,
      <NotAssignComponent mode="badge" has={!!item.phone}>
        {item.phone}
      </NotAssignComponent>,
      <NotAssignComponent mode="badge" has={!!item.email}>
        {item.email}
      </NotAssignComponent>,
      <NotAssignComponent mode="badge" has={!!telegramLink}>
        {telegramLink?.display}
      </NotAssignComponent>,
    ];
  };

  const handleCandidateClick = (personId: number | string) => {
    openModal(
      CandidatePreviewModalComponent,
      {
        personId,
        candidateGroup: CANDIDATES_GROUPS.ALL,
        additionalAction: (
          <>
            {checkUserRequiredPermissions(user.permissions, [
              UserPermissions.CAN_MANAGE_INTERNSHIP_PEOPLE,
            ]) && (
              <ButtonComponent
                appearance="warning"
                handleClick={() => handleConfirmRemoveCandidate(personId)}
              >
                {t('Eliminate candidate')}
              </ButtonComponent>
            )}
          </>
        ),
      },
      {
        position: 'right-top',
      },
    );
  };
  const handleGetList = (
    page: number,
    sort?: string,
    search?: string,
    filter?: any,
  ) => {
    dispatch(
      getInternshipPeopleListThunk({
        id,
        params: {
          page,
          sort,
          search,
          filter,
        },
      }),
    );
  };

  const debounceSetSearchParams = debounce(setSearchParams, 200);

  useEffect(() => {
    handleChangePage(1);
  }, []);

  const handleChangePage = (page: number) => {
    const search = addToQueryString([
      {
        name: 'page',
        value: page,
      },
      { name: 'sort', value: currentSort },
    ]);
    debounceSetSearchParams(search, { replace: true });
    handleGetList(page, currentSort, currentSearch, currentStatuses);
  };

  const handleChangeSort = ({
    sort,
    dataProperty,
  }: TableHeaderItemOrderProps) => {
    const sortDirective = sort === SortTypes.DESC ? '-' : '';
    const sortComplex = `${sortDirective}${dataProperty}`;

    const search = addToQueryString([{
      name: 'sort',
      value: sortComplex,
    }]);
    debounceSetSearchParams(search, { replace: true });
    handleGetList(currentPage, sortComplex, currentSearch, currentStatuses);
  };

  const handleChangeSearch = (searchString: string) => {
    const search = addToQueryString([{
      name: 'search',
      value: searchString || null,
    }]);
    debounceSetSearchParams(search, { replace: true });
    handleGetList(currentPage, currentSort, searchString, currentStatuses);
  };

  const handleStatusesChange = (statuses: SelectOptionProps[]) => {
    const search = addToQueryString([{
      name: 'status',
      value: statuses.map(status => status.value),
    }]);
    debounceSetSearchParams(search, { replace: true });
    handleGetList(currentPage, currentSort, currentSearch, {
      status: statuses.map(status => status.value),
    });
  };

  const debouncedSearchInputChange = useCallback(
    debounce(handleChangeSearch, 300) as Function,
    [],
  );

  const handleSearchInputChange = (value: string) => {
    setSearchString(value);
    debouncedSearchInputChange(value);
  };

  const handleClearClick = () => {
    setSearchString('');
    debouncedSearchInputChange('');
  };

  const formatStatusGroupLabel = (data: SelectGroupedOption) => (
    <StyledStatusGroup>
      <span>{data.label}</span>
    </StyledStatusGroup>
  );

  const handleChangeStatuses = (statuses: SelectOptionProps[]) => {
    setStatuses(statuses);
    handleStatusesChange(statuses);
  };

  const statusLoadOptions = async (
    search: string,
    loadedOptions: string | any[],
    { eventId = 6, page }: any,
  ) => {
    return await getStatusList(search, loadedOptions, {
      eventId,
      page,
    });
  };

  return (
    <StyledInternshipPage>
      <StyledInternshipInfoBlocks>
        <CardComponent>
          <StyledInternshipInfo>
            {!info.loading && info.item ? (
              <InternshipInfoBlockComponent info={info.item} />
            ) : (
              <SpinnerComponent />
            )}
          </StyledInternshipInfo>
        </CardComponent>
        <CardComponent>
          <StyledInternshipInfo>
            {!info.loading && info.item ? (
              <InternshipCommentBlock comment={info.item?.comment} />
            ) : (
              <SpinnerComponent />
            )}
          </StyledInternshipInfo>
        </CardComponent>
        {!info.loading && info.item?.attachments?.length > 0 && (
          <CardComponent>
            <StyledInternshipInfo>
              <StyledInternshipInfoTitle>
                {t('Attachments')}:
              </StyledInternshipInfoTitle>
              <AttachmentsBlockComponent attachments={info.item.attachments} />
            </StyledInternshipInfo>
          </CardComponent>
        )}
      </StyledInternshipInfoBlocks>
      <StyledInternshipRecords>
        {!info.loading ? (
          <React.Fragment>
            <StyledInternshipRecordsHeader>
              <StyledInternshipRecordsHeaderTitle>
                {t('Active candidates')}
              </StyledInternshipRecordsHeaderTitle>
              <StyledInternshipRecordsHeaderActions>
                <StyledFilterWrapper>
                  <SelectComponent
                    isMulti
                    value={statuses}
                    placeholder={t('Choose status')}
                    formatGroupLabel={formatStatusGroupLabel}
                    loadOptions={statusLoadOptions}
                    onChangeOption={handleChangeStatuses}
                  />
                  <InputComponent
                    onClearClick={handleClearClick}
                    value={searchString}
                    placeholder={t('Search name, surname, phone, email')}
                    onChange={handleSearchInputChange}
                  />
                </StyledFilterWrapper>
                {checkUserRequiredPermissions(user.permissions, [
                  UserPermissions.CAN_EDIT_INTERNSHIP,
                ]) && (
                  <ButtonComponent
                    appearance="primary"
                    left={<PlusIcon width={12} height={12} />}
                    handleClick={handleSearchCandidate}
                  >
                    {t('Add candidate')}
                  </ButtonComponent>
                )}
              </StyledInternshipRecordsHeaderActions>
            </StyledInternshipRecordsHeader>
            <CardComponent>
              <TableComponent
                header={TABLE_HEADER_COLUMNS}
                loading={list.loading}
                pagination={{
                  ...list.pagination,
                  currentPage,
                }}
                onSortChange={handleChangeSort}
                onPageChange={handleChangePage}
              >
                {list.items.length > 0 ? (
                  list.items.map((item: Person) => {
                    const personUrl = getUrlBasedOnCurrentPath(
                      location,
                      item.id,
                      [
                        RoutesConstant.CANDIDATES_GROUP,
                        RoutesConstant.CANDIDATE,
                      ],
                      CANDIDATES_GROUPS.ALL,
                    );
                    const canUserViewCandidate = checkUserRequiredPermissions(
                      user.permissions,
                      [UserPermissions.CAN_VIEW_CANDIDATE],
                    );
                    return (
                      <TableRowComponent
                        key={uniqueId('table-rows-')}
                        columns={prepareRowColumns(item)}
                        handleClick={() =>
                          canUserViewCandidate && handleCandidateClick(item.id)
                        }
                        handleDBClick={() =>
                          !!personUrl &&
                          canUserViewCandidate &&
                          navigate(personUrl)
                        }
                      />
                    );
                  })
                ) : (
                  <NoResultComponent />
                )}
              </TableComponent>
            </CardComponent>
          </React.Fragment>
        ) : (
          <SpinnerComponent />
        )}
      </StyledInternshipRecords>
    </StyledInternshipPage>
  );
};

export default InternshipPage;
